'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0px',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0px, 0px, 0px, 0px)',
  border: '0px'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-fontawesome/lib/screen-reader-styles.js
// module id = 1422
// module chunks = 0